module.exports = __webpack_public_path__ + "img/refresh-web.f6a3a6ed.svg";